import { Amplify } from 'aws-amplify'

// Configure Amplify with Cognito settings
const awsConfig = {
  Auth: {
    Cognito: {
      userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID || 'us-east-1_vhUQYXjAF',
      userPoolClientId: import.meta.env.VITE_COGNITO_CLIENT_ID || '7aqiq61eraisicqbrnmam77gau',
      loginWith: {
        oauth: {
          domain: import.meta.env.VITE_COGNITO_DOMAIN || 'bri-auth-dev-583865559711.auth.us-east-1.amazoncognito.com',
          scopes: ['email', 'openid', 'profile'],
          redirectSignIn: [window.location.origin],
          redirectSignOut: [window.location.origin],
          responseType: 'code' as const,
        },
      },
    },
  },
}

Amplify.configure(awsConfig)

if (import.meta.env.DEV) {
  console.debug('Admin Panel Amplify configured with:', {
    userPoolId: awsConfig.Auth.Cognito.userPoolId,
    origin: window.location.origin,
  })
}

export default awsConfig




